import React from 'react';
import { useTranslation } from 'react-i18next';

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from '@codes/ui-kit/components/ui/dropdown-menu';
import { EllipsisVertical } from 'lucide-react';

export interface ChatHeaderProps {
    agentName: string;
    onEdit?: () => void;
    onHistory?: () => void;
    showEditActions?: boolean;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({ agentName, onEdit, onHistory, showEditActions = true }) => {
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-between px-6 py-4">
            <div className="flex items-center gap-3">
                <div className="font-medium">{agentName}</div>
            </div>
            {showEditActions && (
                <DropdownMenu>
                    <DropdownMenuTrigger className="group" onClick={e => e.stopPropagation()}>
                        <EllipsisVertical className="w-4 h-4 text-sub group-hover:text-icon-hover" />
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" className="min-w-[108px] px-3 py-[6px] rounded-lg outline-none">
                        <DropdownMenuItem
                            className="text-xs justify-center"
                            onClick={e => {
                                e.stopPropagation();
                                onEdit?.();
                            }}
                        >
                            {t('agent.catalog.actions.edit')}
                        </DropdownMenuItem>
                        <DropdownMenuSeparator className="my-[6px] bg-[#F4F5F5]"></DropdownMenuSeparator>
                        <DropdownMenuItem
                            className="text-xs justify-center"
                            onClick={e => {
                                e.stopPropagation();
                                onHistory?.();
                            }}
                        >
                            {t('agent.catalog.actions.editHistory')}
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            )}
        </div>
    );
};
